"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toast = void 0;
/* eslint-disable tailwindcss/no-custom-classname */
const tailwind_variants_1 = require("tailwind-variants");
exports.toast = (0, tailwind_variants_1.tv)({
  slots: {
    base: ['p-lg', 'rounded-sm', 'flex', 'text-sm', 'leading-s', 'md:max-w-[480px]', 'max-w-[calc(100%-32px)]', 'items-center', 'w-fit', 'gap-sm', 'fixed', 'left-none', 'right-none', 'mx-auto', 'text-primary', 'focus:outline', 'focus:outline-2', 'animate-slide-up-sm-100', 'data-[toast=hidden]:animate-dissolve-100', 'data-[swipe-left=true]:animate-swipe-left-300', 'z-[2000]', 'border-md', 'outline-offset-2', 'shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1),_0px_4px_6px_-2px_rgba(0,0,0,0.5)]'
    // BoxShadow theme classes are overridden in tailwindPreset and there is no matched value for specified custom class
    ],
    icon: ['size-[24px]', 'flex', 'items-center', 'justify-center', 'text-[18px]'],
    closeIcon: ['w-[24px]', 'h-[24px]', 'flex', 'items-center', 'justify-center', 'text-info-foreground'],
    body: ['gap-lg', 'flex', 'flex-col', 'flex-wrap'],
    action: ['border-sm', 'rounded-2xs', 'py-xs', 'px-md', 'hover:bg-primary', 'hover:bg-opacity-30', 'font-semibold']
  },
  variants: {
    type: {
      info: {
        base: ['bg-tertiary', 'text-info-foreground', 'border-none'],
        action: ['border-neutral']
      },
      success: {
        base: ['text-primary', 'bg-positive-light', 'border-positive'],
        icon: ['text-positive'],
        closeIcon: ['text-primary']
      },
      error: {
        base: ['text-primary', 'bg-critical-light', 'border-critical'],
        icon: ['text-critical'],
        closeIcon: ['text-primary']
      },
      warning: {
        base: ['text-primary', 'bg-caution-soft', 'border-caution'],
        icon: ['text-caution'],
        closeIcon: ['text-primary']
      }
    },
    hasTitle: {
      true: {
        base: ['items-start']
      },
      false: {}
    },
    hasActions: {
      true: {
        base: ['items-start']
      },
      false: {}
    }
  },
  compoundVariants: [],
  defaultVariants: {
    type: 'info',
    hasActions: false,
    hasTitle: false
  }
});
